import axios from 'axios';

const useAxios = axios.create({
	baseURL: `${process.env.REACT_APP_URL_API}`
});

export default useAxios;
